export default {
  path: '/reportManagement',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'detailAccount1',
      name: 'detailAccount1',
      component: () => import('@/pages/reportManagement/detailAccount.vue'),
      meta: {
        keepAlive: true,
        title: '应收账款明细表',
      },
    },
    {
      path: 'summarizing1',
      name: 'summarizing1',
      component: () => import('@/pages/reportManagement/summarizing.vue'),
      meta: {
        keepAlive: true,
        title: '应收账款汇总表',
      },
    },
    {
      path: 'debt',
      name: 'debt',
      component: () => import('@/pages/reportManagement/debt.vue'),
      meta: {
        keepAlive: true,
        title: '客户欠款动态表',
      },
    },
  ],
};
